<template>
    <Toolbar>
      <template #actions>
        <button type="button" class="btn btn-sm btn-light" @click="logout">Sair</button>
      </template>
    </Toolbar>
    <div class="container-xxl">
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <div class="d-flex align-items-center position-relative my-1">
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                        transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                  <path
                      d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                      fill="black"></path>
                </svg>
              </span>
              <input type="search" v-model="search"
                     class="form-control form-control-solid w-250px ps-14"
                     placeholder="Pesquisar local...">
            </div>
          </div>
        </div>
        <div class="card-body py-4">
          <div class="row">
            <div class="col-md-12" v-for="place in places.data" :key="place.id_place">
              <div class="card mt-2">
                <div class="card-header">
                  <div class="card-title">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center">
                        <img class="mw-65px mw-lg-65px me-4" :src="place?.place_logo ?? require('@/assets/images/no-photo.png')" alt="image">
                        <span>{{ place.place_name }}</span>
                        <span
                          v-if="isInactive(place)"
                          class="badge badge-light-danger ms-3"
                        >
                          Inativo
                        </span>
                        <span
                          v-if="place.place_is_marketplace"
                          class="badge badge-light-info ms-3"
                        >
                          Marketplace
                        </span>
                      </div>
                      <div class="mt-2">
                        <i class="bi bi-geo-alt-fill me-2" ></i>
                        <span class="badge badge-success mb-0 text-truncate" style="max-width: 220px;">
                          {{ place.place_address }},
                          {{ place.place_addr_numer }} -
                          {{ place.place_neighborhood }} -
                          {{ place.city_name }}/{{ place.state_initials }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="card-toolbar">
                    <span v-if="isInactive(place)" class="text-muted fs-7 me-3">Acesso bloqueado</span>
                    <button
                      class="btn btn-sm btn-light-primary"
                      :disabled="isInactive(place)"
                      @click="selectPlace(place)"
                    >
                      Selecionar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Pagination :data="places"/>
        </div>
      </div>
    </div>

  <ModalMarketplaceRedirect
    ref="marketplaceModal"
    :place-name="marketplacePlaceName"
    :place-id="marketplacePlaceId"
  />
</template>

<script>
import http from "../../helpers/http";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import ModalMarketplaceRedirect from "../../components/ModalMarketplaceRedirect.vue";
import Pagination from "../../components/Pagination";
import debounce from "../../helpers/debounce";
import { isMarketplacePlace } from "../../helpers/marketplacePlace";
import { isPlaceInactive } from "../../helpers/placeAccess";
import { isSubscriptionBlockedForBilling } from "../../helpers/platformSubscription";

export default {
  name: "Places",
    components: {
        Toolbar,
        ModalMarketplaceRedirect,
        Pagination,
    },
  data() {
    return {
      places: {},
      search: '',
      marketplacePlaceName: '',
      marketplacePlaceId: null,
    }
  },
  created() {
    this.debouncedGetPlaces = debounce(() => {
      this.resetPage();
      this.getPlaces(1);
    }, 400);
    this.getPlaces();
  },
  watch: {
    '$route.query.page'() {
      this.getPlaces();
    },
    search() {
      this.debouncedGetPlaces();
    },
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    isInactive(place) {
      return isPlaceInactive(place);
    },
    logout() {
      Swal.fire({
        title: 'Sair',
        text: 'Tem certeza que deseja sair?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#780f5a',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, Sair!',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        this.$store.dispatch('auth/logout').then(() => {
          window.location.replace('/login');
        });
      });
    },
    async selectPlace(place) {
      if (isPlaceInactive(place)) {
        return;
      }

      if (isMarketplacePlace(place)) {
        this.marketplacePlaceName = place.place_name;
        this.marketplacePlaceId = place.id_place;
        this.$nextTick(() => this.$refs.marketplaceModal?.open());
        return;
      }

      if (isSubscriptionBlockedForBilling(place)) {
        this.$store.dispatch('auth/selectPlace', place);
        this.$router.push('/subscription/overdue');
        return;
      }

      await this.enterPlace(place);
    },
    async enterPlace(place) {
      Echo.leave(`arrivals.${this.$store.state.auth.terminal?.id_terminal}.queues`);

      await this.$store.dispatch('auth/selectPlace', place);
      this.$router.push('/dashboard');
    },
    getPlaces(pageOverride) {
      const page = pageOverride !== undefined ? pageOverride : this.$route.query.page;
      http.get(`/users/${this.userAuth.id_user}/places`, {
        params: {
          page,
          search: this.search,
          per_page: 10,
          paginate: 1,
        },
      }).then((res) => {
        this.places = res.data;

        if (this.$route.query.marketplace_redirect === '1') {
          const marketplacePlace = (this.places.data || []).find((p) => isMarketplacePlace(p));
          if (marketplacePlace) {
            this.marketplacePlaceName = marketplacePlace.place_name;
            this.marketplacePlaceId = marketplacePlace.id_place;
            this.$nextTick(() => this.$refs.marketplaceModal?.open());
          }
        }
      });
    },
    resetPage() {
      const query = {...this.$route.query, page: 1};
      this.$router.push({path: this.$route.path, query});
    },
  }
}
</script>

<style scoped>

</style>
